import type { FC } from 'react'

import { useBootstrapStore } from 'core/stores'

import Favicon from './Favicon'

// Treat "default" and "null" (e.g. from config/jq) as programmatic-only; use default favicon path.
const resolveFaviconHref = (value: string): string => (value === 'default' || value === 'null' ? '/favicon.ico' : value)

// Bootstrap store's company is already merged with companyConfigOverride by
// BorrowerCompanyConfigOverrideProvider when in borrower context.
const SetFavicon: FC = () => {
  const favicon = useBootstrapStore((data) => data?.company?.ui?.favicon)

  if (favicon == null || favicon === '') return null
  return <Favicon href={resolveFaviconHref(favicon)} />
}

export default SetFavicon
